/* eslint-disable no-unused-vars */
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useRouter } from "next/router";
import React, { useState } from "react";
import emailUsData from "../../data/email";
import DeliveryResponse from "./DeliveryResponse";
import styles from "./email-form-node.module.scss";
import EmailForm from "./email-form/EmailForm";
import PreferredResolutionWithChatWidget from "./email-form/PreferredSolutionWithChatWidget";
import EmailQuestions from "./email-questions/EmailQuestions";
import { useFilteredFields } from "./useFilteredFields";

const getShowEmailForm = (t, preferredRes, continueToEmail) => {
  if (t === "problemsWithProduct-problemsOther-online") {
    if (preferredRes === "") return false;
    if (preferredRes !== "Replacement") return true;
    if (preferredRes === "Replacement") {
      return continueToEmail;
    }
  } else {
    return true;
  }
};
function EmailFormNode({
  onSubmitted = () => {},
  source = undefined,
  isLiveChatInEmailUsEnabled = false,
  otherEmailOptionEnabled = false,
  missingItemEmailFormEnabled = false,
}) {
  const [questionsResponse, setQuestionsResponse] = useState(null);
  const { fields, emailFormKey } = useFilteredFields(questionsResponse);

  const [preferredRes, setPreferredRes] = useState("");
  const [enableForm, setEnableForm] = useState(false);
  const [emailTopic, setEmailTopic] = useState("");

  const escalatedComplaintsEnabled = true;
  const emailData = emailUsData(escalatedComplaintsEnabled, otherEmailOptionEnabled, missingItemEmailFormEnabled);
  const handleAllQuestionsAnswered = v => {
    setQuestionsResponse(v);
  };
  const router = useRouter();

  const questionsResponseTree = router?.query?.t;

  const showEmailForm = getShowEmailForm(questionsResponseTree, preferredRes, enableForm);

  const isDeliveryResponse = questionsResponse?.formData?.subject === "Delivery_Query_Track_Delivery";
  return (
    <div className={styles["email-form-node"]}>
      <EmailQuestions
        onFinished={handleAllQuestionsAnswered}
        emailData={emailData}
        isLiveChatInEmailUsEnabled={isLiveChatInEmailUsEnabled}
        setEmailTopic={setEmailTopic}
      />
      {questionsResponse ? (
        <div className={styles["email-form-node__container"]}>
          <div className={styles["email-form-node__inner-container"]}>
            <div className={styles["email-form-node__form"]}>
              {questionsResponse?.formData?.message ? (
                <Message
                  dataTest="message"
                  className={styles.messageBox}
                  type="information"
                  title={questionsResponse.formData.title || "Did you know..."}
                  body={questionsResponse.formData.message}
                  whiteBackground
                  wideTab
                />
              ) : null}
              {fields ? (
                <>
                  {isDeliveryResponse ? <DeliveryResponse /> : null}
                  <div className={styles["email-form-node__form-header"]}>
                    {questionsResponse.formData.message ? (
                      <>
                        <div>Still need to email us?</div>
                        <div>Please provide the following details</div>
                      </>
                    ) : null}
                  </div>

                  {questionsResponseTree === "problemsWithProduct-problemsOther-online" && (
                    <PreferredResolutionWithChatWidget
                      value={preferredRes}
                      onPrefResChange={setPreferredRes}
                      handleEnableForm={setEnableForm}
                      location="problemsWithProduct | problemsWithProduct | other"
                    />
                  )}

                  {showEmailForm && (
                    <EmailForm
                      subject={questionsResponse.formData.subject}
                      shop={questionsResponse.shop}
                      fields={fields}
                      imageMessage={questionsResponse.formData.imageMessage}
                      onSubmitted={onSubmitted}
                      id={emailFormKey}
                      source={source}
                      preferredRes={preferredRes}
                      emailTopic={emailTopic}
                    />
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default EmailFormNode;
